

export const splashCompleteAction = (context, payload = {}, done) => {
  context.dispatcher.emit('splashComplete', payload);

  if(done) {
    done();
  }
};



// WEBPACK FOOTER //
// ./src/js/app/action/splashAction.js